import React from 'react';
import { MailIcon, SettingsIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full bg-slate-900 text-slate-300 py-10 px-4" data-id="element-128">
      <div className="max-w-4xl mx-auto text-center" data-id="element-129">
        <div className="inline-flex items-center gap-2 text-sm font-bold text-white mb-3" data-id="element-130">
          <SettingsIcon className="w-5 h-5 text-green-400" data-id="element-131" />
          <span data-id="element-132">Soporte</span>
        </div>
        <a href="mailto:EbookDreamShop@gmail.com" className="inline-flex items-center gap-2 text-green-300 hover:text-green-200 font-medium" data-id="element-133">
          <MailIcon className="w-4 h-4" data-id="element-134" />
          EbookDreamShop@gmail.com
        </a>

        <div className="mt-6 pt-6 border-t border-slate-700 text-xs text-slate-500" data-id="element-135">
          <p data-id="element-136">
            © {new Date().getFullYear()} Carrera Veterinaria 360 —
            EbookDreamShop. Todos los derechos reservados.
          </p>
          <p className="mt-2 max-w-2xl mx-auto" data-id="element-137">
            Este sitio no forma parte del sitio web de Facebook ni de Facebook
            Inc. Este sitio NO está respaldado por Facebook de ninguna manera.
          </p>
        </div>
      </div>
    </footer>;
}